import {useEffect, useRef} from 'react'
import {useSharedStore} from '../state/shared-store-context'

const INTERACTIVE = ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA', 'LABEL', 'VIDEO', 'AUDIO']
const BOTTOM_REVEAL_THRESHOLD = 32
const SCROLLED_STATE_DEBOUNCE_MS = 128
const SCROLL_KEYS = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' ']

export function useNavbarHideOnScroll() {
    const {actions, sharedState} = useSharedStore()
    const scrollPeak = useRef(window.scrollY)
    const lastScrollY = useRef(window.scrollY)
    const hasUserScrollIntentRef = useRef(false)
    const scrolledRef = useRef(sharedState.scrolledPast320)
    const scrollSuppressedUntilRef = useRef(sharedState.navbarScrollSuppressedUntil || 0)
    const lastScrollSuppressedUntilRef = useRef(sharedState.navbarScrollSuppressedUntil || 0)
    const pendingScrolledRef = useRef(null)
    const debounceTimerRef = useRef(null)

    if ((sharedState.navbarScrollSuppressedUntil || 0) > lastScrollSuppressedUntilRef.current) {
        hasUserScrollIntentRef.current = false
        lastScrollSuppressedUntilRef.current = sharedState.navbarScrollSuppressedUntil || 0
    }
    scrolledRef.current = sharedState.scrolledPast320
    scrollSuppressedUntilRef.current = sharedState.navbarScrollSuppressedUntil || 0

    useEffect(() => {
        const clearPendingScrolledChange = () => {
            pendingScrolledRef.current = null
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
            debounceTimerRef.current = null
        }
        const setScrolledPast320 = (next) => {
            if (next === scrolledRef.current) {
                clearPendingScrolledChange()
                return
            }
            if (next === pendingScrolledRef.current) return
            pendingScrolledRef.current = next
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
            debounceTimerRef.current = setTimeout(() => {
                if (pendingScrolledRef.current !== next) return
                actions.setScrolledPast320(next)
                scrolledRef.current = next
                pendingScrolledRef.current = null
                debounceTimerRef.current = null
            }, SCROLLED_STATE_DEBOUNCE_MS)
        }
        const markUserScrollIntent = () => {
            hasUserScrollIntentRef.current = true
        }
        const markUserKeyScrollIntent = (e) => {
            if (SCROLL_KEYS.includes(e.key)) markUserScrollIntent()
        }
        const handler = () => {
            const y = window.scrollY
            if (!hasUserScrollIntentRef.current || Date.now() < scrollSuppressedUntilRef.current) {
                clearPendingScrolledChange()
                scrollPeak.current = y
                lastScrollY.current = y
                return
            }

            const scrollBottom = y + window.innerHeight
            const pageBottom = document.documentElement.scrollHeight
            const isNearBottom = pageBottom - scrollBottom <= BOTTOM_REVEAL_THRESHOLD
            const scrollingDown = y > lastScrollY.current
            if (scrollingDown && y > scrollPeak.current) scrollPeak.current = y
            if (isNearBottom) {
                setScrolledPast320(false)
                scrollPeak.current = y
            } else if (scrollingDown && y > 16) {
                setScrolledPast320(true)
            } else if (!scrollingDown && y <= scrollPeak.current - 32) {
                setScrolledPast320(false)
                scrollPeak.current = y
            }
            lastScrollY.current = y
        }
        window.addEventListener('wheel', markUserScrollIntent, {passive: true})
        window.addEventListener('touchmove', markUserScrollIntent, {passive: true})
        window.addEventListener('keydown', markUserKeyScrollIntent)
        window.addEventListener('scroll', handler)
        return () => {
            window.removeEventListener('wheel', markUserScrollIntent)
            window.removeEventListener('touchmove', markUserScrollIntent)
            window.removeEventListener('keydown', markUserKeyScrollIntent)
            window.removeEventListener('scroll', handler)
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
        }
    }, [actions])

    // useEffect(() => {
    //     const handler = (e) => {
    //         const hasInteractive = e.composedPath().find(el =>
    //             el.tagName && (INTERACTIVE.includes(el.tagName) || el.onclick && el.id !== 'ʌ⠀ɪ⠀f⠀ə' || el.getAttribute?.('role') === 'button'))
    //         if (!hasInteractive) actions.setScrolledPast320(!scrolledRef.current)
    //     }
    //     window.addEventListener('click', handler)
    //     return () => window.removeEventListener('click', handler)
    // }, [])
}
